import * as React from "react"

const SvgPlayCircle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m10.65 16.178 4.875-3.125a.7.7 0 0 0 .35-.625.7.7 0 0 0-.35-.625L10.65 8.68a.69.69 0 0 0-.763-.038.7.7 0 0 0-.387.663v6.25q0 .45.387.662.388.213.763-.038Zm1.35 6.25a9.7 9.7 0 0 1-3.9-.787 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.176a9.7 9.7 0 0 1-.788-3.9 9.7 9.7 0 0 1 .788-3.9 10.1 10.1 0 0 1 2.137-3.174q1.35-1.35 3.175-2.138a9.7 9.7 0 0 1 3.9-.787 9.7 9.7 0 0 1 3.9.787 10.1 10.1 0 0 1 3.175 2.138q1.35 1.35 2.137 3.175a9.7 9.7 0 0 1 .788 3.9 9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.174q-1.35 1.35-3.175 2.138a9.7 9.7 0 0 1-3.9.788Zm0-2q3.35 0 5.675-2.325T20 12.428t-2.325-5.674Q15.35 4.429 12 4.429T6.325 6.754Q4 9.078 4 12.429q0 3.349 2.325 5.675T12 20.429Z" />
  </svg>
)
export default SvgPlayCircle
